<script>

    let { item } = $props();

</script>

<h3>
    {item.name}
</h3>

<style>

    h3 {
        margin: 3rem 0 0.4rem 0;
        font-family: var(--theme-alt-font-family);
        font-weight: normal;
        font-size: 1.5rem;
    }

</style>
